module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/catering-hospitality-524870b778e07920d8a314b1af4b7418.png";